import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map, pluck, publishReplay, refCount, take } from 'rxjs/operators';

export const EDIT_DEALER_INFO = 'edit-dealer-info';
export const REQUEST_DELETE_ACCOUNT = 'request-delete-account';
export const EDIT_BILLING_ADDRESS = 'edit-billing-address';
export const REQUEST_NEW_DELIVERY_ADDRESS = 'request-new-delivery-address';
export const DELETE_DELIVERY_ADDRESS = 'delete-delivery-address';
export const EDIT_DEFAULT_DELIVERY_ADDRESS = 'edit-default-delivery-address';
export const CHANGE_PASSWORD = 'change-password';
export const MANAGE_EMPLOYEES = 'manage-employees';
export const FLAG_ICON = 'flag-icon';
export const VAT_NUMBER = 'vat-number';
export const COUNTY = 'county';
export const EDIT_ACCOUNT_INFO = 'edit-account-info';
export const COUNTRY_FLAG_INSTEAD = 'country-flag-instead';

@Injectable({
  providedIn: 'root',
})
export class MyaccountFeaturesConfigService {
  // custom myaccount features configurable per country
  MY_ACCOUNT_FEATURES_CONFIG = '../../../public/features/MY_ACCOUNT_FEATURES.json';

  cacheWindowTime = 3600000;
  private cachedMyaccountFeatureEnabled$: any = {};

  constructor(private http: HttpClient) {}

  getMyAccountFeaturesConfig$(activeCountry: string): Observable<any> {
    if (!this.cachedMyaccountFeatureEnabled$[activeCountry]) {
      this.cachedMyaccountFeatureEnabled$[activeCountry] = this.http
        .get(this.MY_ACCOUNT_FEATURES_CONFIG)
        .pipe(publishReplay(1, this.cacheWindowTime), refCount(), take(1), catchError(this.errorHandler));
    }
    return this.cachedMyaccountFeatureEnabled$[activeCountry];
  }

  isMyaccountFeatureEnabled$(activeCountry: string, feature: string): Observable<boolean> {
    const idString = [activeCountry, feature].join();

    if (!this.cachedMyaccountFeatureEnabled$[idString]) {
      this.cachedMyaccountFeatureEnabled$[idString] = this.getMyAccountFeaturesConfig$(activeCountry).pipe(
        publishReplay(1, this.cacheWindowTime),
        refCount(),
        take(1),
        pluck('country'),
        map((data: any) => (data[activeCountry] !== undefined ? data[activeCountry] : data['default'])),
        pluck('feature'),
        map((data) => data[feature]['enabled']),
        catchError(this.errorHandler)
      );
    }
    return this.cachedMyaccountFeatureEnabled$[idString];
  }

  errorHandler(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(errorMessage);
  }
}
